let config: any = {};

if (process.env.NODE_ENV == 'development') {
  config = {
    "AUTH_URL": "http://simplicity/tenantapi/login",
    "BASE_API_URL": "http://simplicity/tenantapi/"
  };
}

export default config;